import { InventoryBoundary } from '@cibo/core'
import { GridColumns } from '@mui/x-data-grid-pro'
import { DataGridPro } from 'consts/Theme'
import { ascend, map, pipe, prop, sort } from 'ramda'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface BasePeriodRow {
  year: number
  soy: number
  corn: number
}

const datagridStyle = {
  '.MuiDataGrid-row--lastVisible': {
    '.MuiDataGrid-cell': {
      borderBottom: 'none',
    },
  },
}

type HistoricalOfftakeTableProps = {
  boundary: InventoryBoundary
  years: number[]
  onRowChanged(change: any): void
}

export const HistoricalOfftakeTable = ({
  boundary,
  years,
  onRowChanged,
}: HistoricalOfftakeTableProps) => {
  const { t } = useTranslation('impact/Inventories/HistoricalOfftake')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')

  const columns = useMemo(() => {
    return [
      {
        field: 'year',
        headerName: t('year'),
        sortable: false,
        width: 70,
      },
      ...boundary.crops.map(({ crop }) => ({
        field: crop,
        sortable: false,
        headerName: t('cropOfftake', { crop: cropT(crop) }),
        editable: true,
        type: 'number',
        flex: 1,
      })),
    ]
  }, [boundary])

  const rows = pipe<number[], { year: number }[], { year: number }[]>(
    map(year => ({ year })),
    sort(ascend(prop('year')))
  )(years)

  return (
    <DataGridPro<BasePeriodRow>
      sx={datagridStyle}
      disableColumnResize
      disableColumnMenu
      hideFooter
      autoHeight
      rows={rows || []}
      getRowId={i => i.year}
      columns={columns as GridColumns<BasePeriodRow>}
      density="compact"
      onEditRowsModelChange={onRowChanged}
    />
  )
}
